<template>
  <div>
    <router-link to="/info" class="nav-link">Политика конфиденциальности</router-link>
    <router-link to="/info/rules" class="nav-link">Лицензионное соглашение</router-link>
    <router-link to="/info/payment" class="nav-link">Способы оплаты</router-link>
    <router-link to="/info/support" class="nav-link">Служба поддержки</router-link>
    <router-link to="/info/contacts" class="nav-link">Контакты</router-link>
    <router-link to="/info/api" class="nav-link">Документация API</router-link>
  </div>
</template>
<script>
  export default {
    name: 'InfoMenu'
  }
</script>
<style></style>
